module.exports = __webpack_public_path__ + "static/media/tennis-banner.48550c15.png";